import { z } from 'zod'

declare const uuid: unique symbol
export type ValidUuidString = string & { readonly [uuid]: true }

export const uuidSchema = z
  .string()
  .uuid()
  .transform((val) => val as ValidUuidString) // Allows us to create a distinct UUID type that TypeScript will not collapse into a plain string.

export function isUuid(value: unknown): value is ValidUuidString {
  return uuidSchema.safeParse(value).success
}

export function parseUuid(value: unknown): ValidUuidString | null {
  return isUuid(value) ? value : null
}
